const formInputsWidth = 300;

const style = (theme): any => ({
    bigAvatar: {},
    partnerInfo: {},
    partnerInfoLabel: {
        color: theme.palette.secondary.light,
    },
    partnerWarningLabel: {
        color: theme.palette.danger.contrastText,
    },
    card: {
        '& .MuiCardContent-root': {
            paddingBottom: 0,
        },
    },
    formInputs: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'start',
        '& .MuiFormControl-root': {
            margin: theme.spacing(1, 2),
        },
    },
    formInput: {
        width: formInputsWidth,
    },
    rightActions: {
        justifyContent: 'flex-end',
    },
});
export default style;
